// 模拟文章数据 - 扩展字段
let mockPosts = [
  {
    id: '1',
    title: 'React 19 新特性详解',
    content: '# React 19 新特性\n\nReact 19 带来了许多令人兴奋的新特性...',
    excerpt: 'React 19 带来了许多令人兴奋的新特性，让我们一起来看看吧。',
    author: '技术小张',
    authorId: 'user1',
    authorAvatar: null,
    createdAt: '2024-01-15T10:30:00Z',
    updatedAt: '2024-01-15T10:30:00Z',
    tags: ['React', '前端', 'JavaScript'],
    category: '技术',
    views: 256,
    likes: 42,
    comments: 12,
    readTime: '5分钟',
    image: null,
    isPublic: true,
    allowComments: true
  },
  {
    id: '2',
    title: 'Node.js 性能优化指南',
    content: '# Node.js 性能优化\n\nNode.js 是一个强大的后端框架...',
    excerpt: '学习如何优化 Node.js 应用的性能',
    author: '后端工程师',
    authorId: 'user2',
    authorAvatar: null,
    createdAt: '2024-01-10T14:20:00Z',
    updatedAt: '2024-01-10T14:20:00Z',
    tags: ['Node.js', '后端', '性能'],
    category: '技术',
    views: 189,
    likes: 35,
    comments: 8,
    readTime: '8分钟',
    image: null,
    isPublic: true,
    allowComments: true
  }
];

// 预定义分类选项
export const categories = ['技术', '生活', '旅行', '读书', '思考', '教程'];

// 预定义标签选项
export const tags = [
  'React', 'Vue', 'JavaScript', 'Node.js', '前端', '后端', 
  '性能优化', 'CSS', 'TypeScript', 'Webpack', 'Docker', '数据库',
  '生活', '旅行', '读书', '思考', '教程', '分享'
];

// 模拟获取文章列表
export const getPosts = async (page = 1, pageSize = 9) => {
  return new Promise(resolve => {
    setTimeout(() => {
      const start = (page - 1) * pageSize;
      const end = start + pageSize;
      const publicPosts = mockPosts.filter(post => post.isPublic);
      resolve(publicPosts.slice(start, end));
    }, 500);
  });
};

// 模拟获取用户自己的文章
export const getUserPosts = async (userId) => {
  return new Promise(resolve => {
    setTimeout(() => {
      const userPosts = mockPosts.filter(post => post.authorId === userId);
      resolve(userPosts);
    }, 500);
  });
};

// 模拟获取归档文章
export const getArchivePosts = async (filters = {}) => {
  return new Promise(resolve => {
    setTimeout(() => {
      const { page = 1, search = '', year = null, tag = null, category = null } = filters;
      let filteredPosts = mockPosts.filter(post => post.isPublic);
      
      if (search) {
        filteredPosts = filteredPosts.filter(post => 
          post.title.toLowerCase().includes(search.toLowerCase()) || 
          post.content.toLowerCase().includes(search.toLowerCase())
        );
      }
      
      if (year) {
        filteredPosts = filteredPosts.filter(post => 
          new Date(post.createdAt).getFullYear() === year
        );
      }
      
      if (tag) {
        filteredPosts = filteredPosts.filter(post => 
          post.tags.includes(tag)
        );
      }
      
      if (category) {
        filteredPosts = filteredPosts.filter(post => 
          post.category === category
        );
      }
      
      const start = (page - 1) * 10;
      const end = start + 10;
      
      resolve({
        posts: filteredPosts.slice(start, end),
        total: filteredPosts.length
      });
    }, 500);
  });
};

// 模拟获取单篇文章
export const getPostById = async (id) => {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      const post = mockPosts.find(p => p.id === id);
      if (post) {
        resolve({
          post,
          comments: [],
          userLiked: false
        });
      } else {
        reject(new Error('文章不存在'));
      }
    }, 500);
  });
};

// 模拟保存文章（发布或更新）
export const savePost = async (postData, userId) => {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      try {
        // 如果是编辑已有文章
        if (postData.id) {
          const index = mockPosts.findIndex(p => p.id === postData.id);
          if (index !== -1) {
            // 检查权限
            if (mockPosts[index].authorId !== userId) {
              reject(new Error('无权编辑此文章'));
              return;
            }
            
            mockPosts[index] = {
              ...mockPosts[index],
              ...postData,
              updatedAt: new Date().toISOString()
            };
            resolve({ success: true, id: postData.id, message: '文章更新成功' });
          } else {
            reject(new Error('文章不存在'));
          }
        } 
        // 如果是发布新文章
        else {
          const newPost = {
            ...postData,
            id: Date.now().toString(),
            authorId: userId,
            createdAt: new Date().toISOString(),
            updatedAt: new Date().toISOString(),
            views: 0,
            likes: 0,
            comments: 0
          };
          
          mockPosts.unshift(newPost);
          resolve({ success: true, id: newPost.id, message: '文章发布成功' });
        }
      } catch (error) {
        reject(error);
      }
    }, 800);
  });
};

// 模拟删除文章
export const deletePost = async (postId, userId) => {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      const index = mockPosts.findIndex(p => p.id === postId);
      if (index === -1) {
        reject(new Error('文章不存在'));
        return;
      }
      
      // 检查权限
      if (mockPosts[index].authorId !== userId) {
        reject(new Error('无权删除此文章'));
        return;
      }
      
      mockPosts.splice(index, 1);
      resolve({ success: true, message: '文章删除成功' });
    }, 500);
  });
};

// 模拟点赞
export const likePost = async (postId) => {
  return new Promise(resolve => {
    setTimeout(() => {
      console.log('点赞文章:', postId);
      resolve({ success: true });
    }, 500);
  });
};

// 模拟添加评论
export const addComment = async (postId, content) => {
  return new Promise(resolve => {
    setTimeout(() => {
      const comment = {
        id: Date.now().toString(),
        author: '当前用户',
        avatar: null,
        content,
        createdAt: new Date().toISOString(),
        likes: 0
      };
      resolve(comment);
    }, 500);
  });
};